<template>
  <div
    v-if="showLoadingState < 3"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="productWaysOfSales"
    class="m-edition-section-content-subject m-edition-asset-contents"
  >
    <div v-if="nodos.length">
      <form autocomplete="off"
        name="update-proyecto-form"
        @submit.prevent="updateContenidoActivarNodos"
      >
      <div class="font-size-small m-edition-asset-activation-inmediate-general margin-bottom-small text-align-right ">
        <span
          class="a-tooltip-secondary a-tooltip-bottom margin-right-large text-color-black-35"
          :data-tooltip-text="$t('mEditionAssetActivation.messages.activeZero')"
        >
          <i class="fas fa-info-circle"></i>
          Info
        </span>
        <a
          class="margin-right-large text-link-hover-danger"
          href="#"
          @click.prevent="disableAll"
        >
          <i class="far fa-times-circle"></i>
          {{ $t('mEditionAssetActivation.immediate.disableAll') }}
        </a>
        <label
          class="margin-right-small text-color-success"
           for="dia"
        >
          {{ $t('mEditionAssetActivation.immediate.enableAll') }}
        </label>
        <input
          v-model="diaEntregaGeneral"
          id="dia"
          class="a-input-primary text-align-center width-25-px"
          min="0"
          name="dia"
          type="number"
          @keyup="enableAll"
        />
        <AtomButtonPrimary
          :button-primary="buttonPrimary.nodo"
        />
      </div>
        <MoleculeEditionAssetContentsTreeNode
            v-for="nodo in nodos"
            :key="nodo.id"
            :contenido="version"
            :element="element"
            :info="{ nodosActivos: Object.assign({}, nodosActivos) }"
            :is-child="false"
            :nodo="nodo"
            node-actions="ActivationInmediate"
            node-actions-class="displayed"
            @emitAction="changeActivationDay"
          />
      </form>
    </div>

  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAssetActivationInmediate',

  components: {
    MoleculeEditionAssetContentsTreeNode: () => import('@/components/molecules/MoleculeEditionAssetContentsTreeNode')
  },

  props: {
    element: Object
  },

  data () {
    return {
      activacion: 0,

      buttonPrimary: {
        nodo: {
          action: 'GUARDAR',
          class: 'a-button-assets-primary',
          sending: false,
          type: 'submit'
        }
      },

      buttonSecondary: {
        class: 'a-button-assets-secondary',
        component: '',
        icon: 'fas fa-list',
        method: 'enableAll',
        text: 'Aplicar',
        type: 'button'
      },

      contenidos: [],
      diaEntregaGeneral: '',
      entregablesProyecto: [],

      filters: {
        limite: 1000000
      },

      nodos: [],

      nodosActivos: {
        academia: '',
        nodos: []
      },

      showLoadingState: 0,
      version: 0
    }
  },

  created () {
    this.nodosActivos.academia = this.$store.getters.getAcademyData.id
    this.activacion = this.element.fecha_inicio ? 1 : 0
    this.readContenidos()
  },

  methods: {
    changeActivationDay (activo) {
      let index = this.nodosActivos.nodos.findIndex(nodo => nodo.nodo === activo.nodo)
      activo.dia === '' ? this.nodosActivos.nodos[index].dia = -1 : this.nodosActivos.nodos[index].dia = activo.dia
    },

    disableAll () {
      this.diaEntregaGeneral = ''
      this.nodosActivos.nodos.forEach(nodo => {
        nodo.dia = -1
      })
    },

    enableAll () {
      if (this.diaEntregaGeneral >= 0 && this.diaEntregaGeneral !== '') {
        this.nodosActivos.nodos.forEach(nodo => {
          nodo.dia = this.diaEntregaGeneral
        })
      }
    },

    readContenidos () {
      this.$services.read('contenido', 'readContenidos', {}, [this.$route.params.id])
        .then(response => {
          this.contenidos = response.data
          // versión creada by default al crear el proyecto
          this.version = this.contenidos[0]
          this.readContenidoEntregables()
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    },

    readContenidoEntregables () {
      this.$services.read('contenido', 'readContenidoEntregables', {}, [this.version.id], this.filters)
        .then(response => {
          this.entregablesProyecto = response.data.entregables
          this.readContenidoNodos()
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    },

    readContenidoNodos () {
      this.$services.read('contenido', 'readContenidoNodos', {}, [this.version.id])
        .then(response => {
          this.nodos = response.data
          this.nodos.forEach(nodo => {
            this.setNodosActivos(nodo)
          })
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    },

    setNodosActivos (nodo) {
      this.nodosActivos.nodos.push({ nodo: nodo.id, dia: -1 })

      for (let i = 0; i < this.entregablesProyecto.length; i++) {
        if (this.entregablesProyecto[i].tipo === 'nodo' &&
          this.entregablesProyecto[i].nodos.length > 0 &&
          this.entregablesProyecto[i].nodos.find(enodo => enodo.nodo === nodo.id)) {
          this.nodosActivos.nodos[this.nodosActivos.nodos.length - 1].dia = this.entregablesProyecto[i].dia
          break
        }
      }

      if (nodo.children.length > 0) {
        nodo.children.forEach(child => {
          this.setNodosActivos(child)
        })
      }
    },

    updateContenidoActivarNodos () {
      if (!this.buttonPrimary.nodo.sending) {
        this.diaEntregaGeneral = ''
        this.buttonPrimary.nodo.sending = true
        this.$services.create('contenido', 'updateContenidoActivarNodos', this.nodosActivos, [this.version.id])
          .then(response => {
            this.$modal.updateData('readContenidoEntregables')
            this.$alerts.pushAlert('mEditionAssetActivation', 'updateContenidoActivarNodos', 'success')
            this.buttonPrimary.nodo.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionAssetActivation', 'updateContenidoActivarNodos', 'error', 'a-alert-danger')
            this.buttonPrimary.nodo.sending = false
          })
      }
    }
  }
}
</script>
